import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCoursetypes } from '../../../../../redux/actions/coursetypes'
import { IRootState } from '../../../../../redux/types'
import useGeneralSummaryReport from '../../../../shared/hooks/useGeneralSummaryReport'

function useHandleData() {
  const dispatch = useDispatch()

  const { coursetypes } = useSelector((state: IRootState) => state.coursetype)
  const { courses, coursesProgress, loading } = useSelector((state: IRootState) => state.course)
  const { globalLanguageId } = useSelector((state: IRootState) => state.global)

  useEffect(() => {
    if (globalLanguageId !== null) {
      dispatch(getCoursetypes())
    }
  }, [globalLanguageId])

  useGeneralSummaryReport(3)

  return {
    coursetypes,
    courses,
    coursesProgress,
    loading
  }
}

export default useHandleData
